import { PageController } from '@client/components/_core/layout/PageController';
import { CorrectPaymentDrawer } from '@client/components/claims/financials/payment-approval/AddPaymentDrawer';
import { ENABLE_CLAIM_PAYMENT_APPROVAL_FLAG } from '@shared/constants';
import { createFileRoute } from '@tanstack/react-router';

/**
 * CUR-2672 (PAY-A8): Correct payment, the Add payment drawer filled in from a returned payment, which its
 * raiser corrects and sends again. Opened from the Payment overlay's "Edit and resend".
 */
export const Route = createFileRoute('/console/$orgId/claims/details/$id/financials/payments/correct/$compensationId')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Correct payment',
        },
        featureFlag: ENABLE_CLAIM_PAYMENT_APPROVAL_FLAG,
    },
    params: {
        parse({ compensationId }) {
            return {
                compensationId: BigInt(compensationId),
            };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { id: claimId, compensationId } = Route.useParams();
    return (
        <PageController route={Route}>
            <CorrectPaymentDrawer claimId={claimId} compensationId={compensationId} />
        </PageController>
    );
}
